import React from 'react';
import PropTypes from 'prop-types';
import withInit from 'WithInit';
import classNames from 'classnames';

const StaticBuilderDocumentPreviewTitle = (props) => {
  const titleClass = classNames(
    'document-preview-title',
    'static-builder',
    props.titleClass,
  );
  return (
    <h2 className={titleClass}>{props.titleText}</h2>
  );
};

StaticBuilderDocumentPreviewTitle.defaultProps = {
  titleClass: '',
  titleText: 'DOCUMENT PREVIEW',
};

StaticBuilderDocumentPreviewTitle.propTypes = {
  titleClass: PropTypes.string,
  titleText: PropTypes.string,
};

export default withInit(StaticBuilderDocumentPreviewTitle);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/StaticBuilderDocumentPreviewTitle.jsx